import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DriversHitchCalendarDay } from '../../types';

@Component({
  selector: 'lohi-calendar-events-dialog',
  templateUrl: './calendar-events-dialog.component.html',
  styleUrls: [],
})
export class CalendarEventsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<CalendarEventsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DriversHitchCalendarDay,
  ) {}

  public ngOnInit() {}
}
